import type { TurnstileProof } from './turnstile.types';

export const TURNSTILE_TOKEN_HEADER = 'X-Turnstile-Token';
export const TURNSTILE_CLIENT_HEADER = 'X-Turnstile-Client';

/** Widget actions; the server logs one that differs from the endpoint's. */
export const TURNSTILE_ACTIONS = { login: 'login', decode: 'decode' } as const;

export const SCRIPT_LOAD_TIMEOUT_MS = 15000;
export const SUBMIT_TOKEN_WAIT_MS = 10000;
export const OPEN_TOKEN_WAIT_MS = 15000;
export const INTERACTION_WAIT_MS = 60000;
export const CHALLENGE_WATCHDOG_MS = 30000;
/** Renews ahead of Cloudflare's 300 s token expiry. */
export const TOKEN_MAX_AGE_MS = 280000;

/** Cloudflare's non-retryable errors for a bad, unknown or disabled site key, or a host the widget does not list. */
export const WIDGET_CONFIG_ERROR_CODES: readonly string[] = [
  '110100',
  '110110',
  '110200',
  '400020',
  '400021',
  '400070',
];

/** Prefix of a retryable widget error's reason; Cloudflare retries these itself. */
export const WIDGET_ERROR_PREFIX = 'widget-error-';

/** What the server keeps from an `X-Turnstile-Client` hint. */
export const HINT_PATTERN = /^[a-z0-9-]{1,40}$/;

const BLOCKED_HINTS: readonly string[] = [
  'script-error',
  'script-timeout',
  'render-error',
  'unsupported',
  'challenge-timeout',
];

/** True when the proof is a hint that the check could not run in this browser or network. */
export const isBlockedHint = (proof: TurnstileProof): boolean =>
  proof !== null &&
  'hint' in proof &&
  (BLOCKED_HINTS.includes(proof.hint) ||
    proof.hint.startsWith(WIDGET_ERROR_PREFIX));
